import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { NoteAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-note-slot',
    templateUrl: './note-slot.component.html',
    styleUrl: './note-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoteSlotComponent implements SheetSlotComponentBase {

	@Input() action!: NoteAction;
	value = null;

	constructor() {
	}
}